import { createActionGroup, emptyProps, props } from '@ngrx/store';

import type { CompanyUserListModel } from './company-users-state.model';

export const CompanyUsersStateActions = createActionGroup({
  source: 'Company Users',
  events: {
    Fetch: emptyProps(),
    'Fetch Success': props<{ companyUsers: CompanyUserListModel[] }>(),
    'App Logout': emptyProps(),
    'Delete Current Company User': props<{ userId: string }>(),
    'Add One': props<{ entity: CompanyUserListModel }>(),
    'Remove One': props<{ userId: string }>(),
  },
});
